if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();

      if ( this.querySelector('css-slider') ) {
        this.querySelector('css-slider').addEventListener('ready', ()=>{
          this.init();
        })
      } else {
        this.init();
      }

    }

    initBundler() {

      this._bundleMin = parseInt(this.dataset.minimum);
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);

      this._discountBadge = this.querySelector('[data-js-bundler-discount-badge]');
      this._qualifyingIds = new Set();
      const qualifyingData = this.querySelector('[data-js-bundler-qualifying]');
      if ( qualifyingData ) {
        try {
          JSON.parse(qualifyingData.textContent).forEach(id=>this._qualifyingIds.add(String(id)));
        } catch(e) {}
      }

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });

      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{

        if ( ! this.findEmptySlot() ) {

          let items = [];
          this.bundleProducts.map(elm=>{
            if ( elm.dataset.id ) {
              if ( ! items.find(item => {
                if ( item.id == elm.dataset.id ) {
                  item.quantity++;
                  return true;
                }
              }) ) {
                items.push({
                  id: elm.dataset.id,
                  quantity: 1,
                  properties: { '_source': 'builder' }
                })
              }
            }
          })

          if ( items.length > 0 ) {

            const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
            submitButton.classList.add('working');
            window.handleAddToCart(
              JSON.stringify({'items': items}), items.reduce((total, { quantity }) => total + quantity, 0),
              { 'Content-Type': 'application/json' },
              ()=>{
                submitButton.classList.remove('working');
                this.querySelectorAll('[data-js-bundler-product]').forEach(elm=>{
                  this.clearSlot(elm);
                });
                this.classList.remove('opened');
              }
            );

          }

        }

      });

    }

    initProducts() {

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
        if ( ! elm.hasAttribute('data-init') ) {

          elm.addEventListener('click', e=>{
            e.preventDefault();
            const product = e.target.closest('[data-js-product-item]');
            product.querySelector('.button__text').innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
            const variant = product.querySelector('product-variants').currentVariant;
            this.addToBundle(variant, product);
            this.classList.add('opened');
          });
          elm.setAttribute('data-init', '');

          elm.closest('.product-item').addEventListener('reload', e=>{
            this.initProducts();
          });

        }
      });

    }

    initWizard() {

      this._config = null;
      const configData = this.querySelector('[data-js-builder-config]');
      if ( configData ) {
        try {
          this._config = JSON.parse(configData.textContent);
        } catch(e) {}
      }
      if ( ! this._config || ! this._config.steps || this._config.steps.length < 2 ) {
        this._config = null;
        return;
      }

      ['lock','incompatible','included','removed','recommended','deckUpsell','unideckBadge','tubebags'].forEach(k=>{
        if ( ! this._config.texts[k] ) {
          this._config.texts[k] = '';
        }
      });
      ['tubebagsBoats','deckCapable','integratedDeck'].forEach(k=>{
        if ( ! this._config[k] ) {
          this._config[k] = [];
        }
      });
      if ( ! this._config.unideckSizes ) {
        this._config.unideckSizes = {};
      }

      this._boat = null;
      this._hadBoat = false;
      this._skipped = {};
      this._noticeTimer = null;
      this._notice = this.querySelector('[data-js-bundler-notice]');
      this._vakt = this.querySelector('[data-js-bundler-vakt]');

      this._wizardItems = [...document.querySelectorAll('.builder-item')].map(wrap=>{
        const card = wrap.firstElementChild;
        const handle = wrap.dataset.handle;
        if ( card ) {
          const note = document.createElement('span');
          note.className = 'builder-item__note text-size--small';
          note.hidden = true;
          card.appendChild(note);
          const badge = document.createElement('span');
          badge.className = 'builder-item__badge text-size--small';
          badge.hidden = true;
          card.appendChild(badge);
        }
        return {
          wrap: wrap,
          card: card,
          handle: handle,
          step: parseInt(wrap.dataset.step) || ( this._config.productSteps[handle] || 1 )
        };
      });

      if ( this._config.texts.tubebags ) {
        this._wizardItems.forEach(item=>{
          if ( item.card && this._config.tubebagsBoats.indexOf(item.handle) !== -1 ) {
            const tb = document.createElement('span');
            tb.className = 'builder-item__tubebags text-size--small text-color--opacity';
            tb.textContent = this._config.texts.tubebags;
            item.card.appendChild(tb);
          }
        });
      }

      this.querySelectorAll('[data-js-boat-filter-chip]').forEach(chip=>{
        chip.addEventListener('click', ()=>{
          const f = chip.dataset.jsBoatFilterChip;
          this.querySelectorAll('[data-js-boat-filter-chip]').forEach(c=>{
            c.classList.toggle('bundler-boat-filter__chip--active', c === chip);
          });
          this._wizardItems.forEach(item=>{
            if ( item.step !== 1 ) {
              return;
            }
            const flags = ( item.wrap.dataset.boatFilter || '' ).split(' ');
            item.wrap.style.display = ( f === 'alle' || flags.indexOf(f) !== -1 ) ? '' : 'none';
          });
        });
      });

      this.querySelectorAll('[data-js-step-skip]').forEach(btn=>{
        btn.addEventListener('click', ()=>{
          const n = parseInt(btn.dataset.jsStepSkip);
          this._skipped[n] = true;
          const next = document.querySelector('[data-js-step-header="' + ( n + 1 ) + '"]');
          if ( next ) {
            next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            const panel = this.querySelector('.bundler');
            if ( panel ) {
              panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          this.updateWizard();
        });
      });

      this.querySelectorAll('[data-js-chip]').forEach(chip=>{
        chip.addEventListener('click', ()=>{
          const n = parseInt(chip.dataset.jsChip);
          const header = document.querySelector('[data-js-step-header="' + n + '"]');
          if ( header ) {
            header.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      const swap = this.querySelector('[data-js-vakt-swap]');
      if ( swap ) {
        swap.addEventListener('click', ()=>{
          this.swapXlSeatForBlockSeat();
        });
      }

      this.updateWizard();

    }

    boatDisplayName(handle) {
      const item = ( this._wizardItems || [] ).find(i=>i.handle === handle);
      if ( item && item.card ) {
        const titleEl = item.card.querySelector('[data-js-quick-buy-product-title]');
        if ( titleEl ) {
          return titleEl.textContent.split('—')[0].replace('Anfibio', '').trim();
        }
      }
      return handle;
    }

    filledSlots() {
      return ( this.bundleProducts || [] ).filter(elm=>{
        return ! elm.classList.contains('bundler-product--empty') && elm.dataset.handle;
      });
    }

    bundleHasHandle(handle) {
      return this.filledSlots().some(s=>s.dataset.handle === handle);
    }

    showNotice(text) {
      if ( ! this._notice || ! text ) {
        return;
      }
      this._notice.textContent = text;
      this._notice.hidden = false;
      clearTimeout(this._noticeTimer);
      this._noticeTimer = setTimeout(()=>{
        this._notice.hidden = true;
      }, 7000);
    }

    swapXlSeatForBlockSeat() {
      const xlSlot = this.filledSlots().find(s=>s.dataset.handle === this._config.xlSeat);
      if ( xlSlot ) {
        this.clearSlot(xlSlot);
      }
      const blockItem = this._wizardItems.find(i=>i.handle === this._config.blockSeat);
      if ( blockItem && ! this.bundleHasHandle(this._config.blockSeat) ) {
        const addBtn = blockItem.card ? blockItem.card.querySelector('[data-js-product-add-to-cart]') : null;
        if ( addBtn ) {
          addBtn.click();
        } else {
          blockItem.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    updateVakt() {
      if ( ! this._vakt || ! this._config ) {
        return;
      }
      const active = this._boat === this._config.vaktBoat
        && this.bundleHasHandle(this._config.xlSeat)
        && this._config.mats.some(m=>this.bundleHasHandle(m));
      this._vakt.hidden = ! active;
    }

    updateWizard() {

      if ( ! this._config || this._updatingWizard ) {
        return;
      }
      this._updatingWizard = true;

      const boats = this.filledSlots().filter(s=>{
        return ( this._config.productSteps[s.dataset.handle] || 1 ) === 1;
      });
      if ( ! boats.length ) {
        this._boat = null;
      } else if ( ! this._boat || ! boats.some(s=>s.dataset.handle === this._boat) ) {
        this._boat = boats[boats.length - 1].dataset.handle;
      }

      const boat = this._boat;
      const boatName = boat ? this.boatDisplayName(boat) : '';
      const texts = this._config.texts;

      if ( boat ) {
        this.filledSlots().forEach(slot=>{
          const h = slot.dataset.handle;
          const fits = this._config.fits[h];
          const step = this._config.productSteps[h] || 1;
          if ( step > 1 && fits && fits.indexOf(boat) === -1 ) {
            const name = this.boatDisplayName(h);
            this.clearSlot(slot);
            if ( texts.removed ) {
              this.showNotice(texts.removed.replace('{product}', name).replace('{boat}', boatName));
            }
          }
        });
      }

      this._wizardItems.forEach(item=>{
        if ( ! item.card || item.step === 1 ) {
          return;
        }
        const note = item.card.querySelector('.builder-item__note');
        const badge = item.card.querySelector('.builder-item__badge');
        item.card.classList.remove('builder-card--locked', 'builder-card--incompatible');
        if ( note ) {
          note.hidden = true;
        }
        if ( badge ) {
          badge.hidden = true;
        }
        // Task 162: progressiv avdekking — skjul (display:none) steg>1 til en båt er valgt
        if ( ! boat ) {
          item.wrap.style.display = 'none';
          return;
        }
        // Task 162: kontekstuell filtrering — SKJUL inkompatible (ikke dim); universelle vises alltid
        item.wrap.style.display = '';
        const fits = this._config.fits[item.handle];
        if ( fits && fits.indexOf(boat) === -1 ) {
          item.wrap.style.display = 'none';
          return;
        }
        const rec = this._config.recommended[boat];
        if ( badge && rec && texts.recommended && rec.indexOf(item.handle) !== -1 ) {
          badge.textContent = texts.recommended.replace('{boat}', boatName);
          badge.hidden = false;
        }
      });

      // Task 162: UniDeck — bevart DeckReady-logikk, tilpasset skjul-modellen
      const ud = this._wizardItems.find(i=>i.handle === this._config.unideck);
      if ( ud && ud.card ) {
        const udNote = ud.card.querySelector('.builder-item__note');
        const udBadge = ud.card.querySelector('.builder-item__badge');
        ud.card.classList.remove('builder-card--incompatible', 'builder-card--locked');
        if ( udNote ) { udNote.hidden = true; }
        if ( udBadge ) { udBadge.hidden = true; }
        if ( ! boat || this._config.integratedDeck.indexOf(boat) !== -1 ) {
          ud.wrap.style.display = 'none';
        } else if ( this._config.deckCapable.indexOf(boat) !== -1 ) {
          ud.wrap.style.display = '';
          const boatSlot = this.filledSlots().filter(s=>s.dataset.handle === boat).pop();
          const variantTitle = boatSlot ? ( boatSlot.dataset.variantTitle || '' ) : '';
          if ( variantTitle.indexOf('DeckReady') !== -1 ) {
            if ( udBadge && texts.unideckBadge ) {
              udBadge.textContent = texts.unideckBadge.replace('{size}', this._config.unideckSizes[boat] || '').replace('{boat}', boatName);
              udBadge.hidden = false;
            }
          } else {
            ud.card.classList.add('builder-card--incompatible');
            if ( udNote && texts.deckUpsell ) {
              udNote.textContent = texts.deckUpsell.replace('{boat}', boatName);
              udNote.hidden = false;
            }
          }
        } else {
          ud.wrap.style.display = 'none';
        }
      }

      // Task 162: avdekk/skjul steg-headere (steg>1) etter båtvalg; skjul tomme steg
      this._config.steps.forEach(step=>{
        if ( step.n <= 1 ) {
          return;
        }
        const header = document.querySelector('[data-js-step-header="' + step.n + '"]');
        if ( ! header ) {
          return;
        }
        if ( ! boat ) {
          header.style.display = 'none';
          return;
        }
        const hasVisible = this._wizardItems.some(it=>it.step === step.n && it.wrap && it.wrap.style.display !== 'none');
        header.style.display = hasVisible ? '' : 'none';
      });

      // Task 162: auto-scroll til første avdekte steg når en båt nettopp ble valgt
      if ( boat && ! this._hadBoat ) {
        const firstStep = ( this._config.steps || [] )
          .map(s=>s.n).filter(n=>n > 1)
          .map(n=>document.querySelector('[data-js-step-header="' + n + '"]'))
          .find(h=>h && h.style.display !== 'none');
        if ( firstStep ) {
          setTimeout(()=>{ firstStep.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
        }
      }
      this._hadBoat = ! ! boat;

      const stepTwoNote = document.querySelector('[data-js-step-note="2"]');
      if ( stepTwoNote ) {
        if ( boat && this._config.includedBoats.indexOf(boat) !== -1 && texts.included ) {
          stepTwoNote.textContent = texts.included.replace('{boat}', boatName);
          stepTwoNote.hidden = false;
        } else {
          stepTwoNote.hidden = true;
        }
      }

      this._config.steps.forEach(step=>{
        const chip = this.querySelector('[data-js-chip="' + step.n + '"]');
        if ( ! chip ) {
          return;
        }
        const status = chip.querySelector('[data-js-chip-status]');
        const hasItem = this.filledSlots().some(s=>( this._config.productSteps[s.dataset.handle] || 1 ) === step.n);
        chip.classList.remove('bundler-chip--done', 'bundler-chip--skipped', 'bundler-chip--locked');
        if ( hasItem ) {
          chip.classList.add('bundler-chip--done');
          if ( status ) status.textContent = '✓';
        } else if ( this._skipped[step.n] ) {
          chip.classList.add('bundler-chip--skipped');
          if ( status ) status.textContent = '–';
        } else if ( step.n > 1 && ! boat ) {
          chip.classList.add('bundler-chip--locked');
          if ( status ) status.textContent = '';
        } else {
          if ( status ) status.textContent = '';
        }
      });

      this.updateVakt();
      this._updatingWizard = false;

    }

    init() {
      this.initBundler();
      this.initProducts();
      this.initWizard();
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }

    clearSlot(slot) {
      slot.product.querySelector('[data-js-product-add-to-cart-text]').textContent = KROWN.settings.locales.products_add_to_bundle_button;
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        slot.product.classList.remove('product-item--bundled');
        slot.remove();
      } else {
        slot.product.classList.remove('product-item--bundled');
        slot.dataset.id = "";
        slot.dataset.variant = null;
        slot.dataset.variantTitle = "";
        slot.dataset.handle = "";
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }
      if ( this.findEmptySlot() ) {
        this.classList.remove('bundler-full');
      }
      this.reorderSlots();
      this.updateDiscountBadge();
      if ( ! this._updatingWizard ) {
        this.updateWizard();
      }
    }

    updateDiscountBadge() {
      if ( ! this._discountBadge ) {
        return;
      }
      const active = this.bundleProducts.some(elm=>{
        return ! elm.classList.contains('bundler-product--empty') && elm.dataset.id && this._qualifyingIds.has(String(elm.dataset.id));
      });
      this._discountBadge.hidden = ! active;
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if ( slot ) {

        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
        slot.dataset.variant = product.querySelector('product-variants').currentVariant;
        slot.dataset.variantTitle = variant && variant.title ? variant.title : '';
        const wrap = product.closest('.builder-item');
        slot.dataset.handle = wrap ? wrap.dataset.handle : '';
        if ( this._config && slot.dataset.handle && ( this._config.productSteps[slot.dataset.handle] || 1 ) === 1 ) {
          this._boat = slot.dataset.handle;
        }

      } else {
        // when bundle is full, show message
      }

      if ( ! this.findEmptySlot() ) {
        this.classList.add('bundler-full');
      }

      this.updateDiscountBadge();
      this.updateWizard();

    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}
